import { render, staticRenderFns } from "./OrderStatusesTable.vue?vue&type=template&id=ad58c320"
import script from "./OrderStatusesTable.vue?vue&type=script&lang=ts"
export * from "./OrderStatusesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports